import { createFileRoute } from '@tanstack/react-router'
import RegisterAccount from '../../../../containers/register'

export const Route = createFileRoute(
  '/_unauthenticated/register/$invitedToken/'
)({
  component: RegisterAccount
})
